import VanillaTilt from 'vanilla-tilt';
import { isMobile } from '../common/DeviceHelper';

function init() {
	const ANIMATION_SPEED = 400;
	const MAX_TILT_ROTATION = 25;
	const EASING = '0.3s ease-in-out';

	const buttonNodes = document.querySelectorAll('[data-services-button]');
	if ((buttonNodes && buttonNodes.length === 0) || isMobile.matches) return;

	buttonNodes.forEach(node => {
		VanillaTilt.init(node, {
			speed: ANIMATION_SPEED,
			max: MAX_TILT_ROTATION,
			easing: EASING,
		});
	});
}

export default init;
